import { Controller } from "@hotwired/stimulus"
import Autocomplete from "bootstrap5-autocomplete";

// Connects to data-controller="autocomplete"
export default class extends Controller {
  connect() {
    let a = Autocomplete.init('input.autocomplete', {
      liveServer: false,
    });
  }
}
